import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import Logos from './Logos';
import Review from './Review';
import Footer from './Footer';
import { useNavigate } from 'react-router-dom';
import { toWords } from 'number-to-words'; // Import the library


export default function Bike() {
  const [bikeMake, setBikeMake] = useState([]);
  const [bikeModel, setBikeModel] = useState([]);
  const [words, setWords] = useState('');  // To store words equivalent of the number
  const [number, setNumber] = useState(''); // To store numeric input

  const newMake = useRef('');
  const newURL = useRef('');
  const navigate = useNavigate();
  const BASE_URL = 'https://node.insuranceadvisors.pk';

  
  const handleChange = (event) => {
    newMake.current = event.currentTarget.value;
    newURL.current = BASE_URL + '/api/findbike/' + newMake.current;
    // newURL.current = 'http://localhost:8000/api/findbike/' + newMake.current;

    getAllProductModel();
    event.preventDefault();
  };

  const getAllProductModel = async () => {
    try {
      const response = await axios.get(newURL.current);
      setBikeModel(response.data);
    } catch (error) {
      console.error('Error fetching product models:', error);
    }
  };

  const getAllProductMake = () => {
    const url = BASE_URL + '/api/findbike';
    // const url = 'http://localhost:8000/api/findbike';
    axios.get(url)
      .then((res) => setBikeMake(res.data))
      .catch((err) => console.error('Error fetching product makes:', err));
  };

   // Handle changes in the estimated value input
   const handleEstimatedValueChange = (e) => {
    const value = e.target.value;
    setNumber(value); // Update numeric value

    // Convert number to words and set the words state
    if (value) {
      setWords(toWords(parseInt(value))); // Convert number to words
    } else {
      setWords(''); // Clear words if input is empty
    }
  };

  useEffect(() => {
    getAllProductMake();
  }, []);

  const saveBikeOrder = async (event) => {
    event.preventDefault();
    const saveapi = BASE_URL + "/api/savebikeorder";
    // const saveapi =  "localhost:8000/api/savebikeorder";


    const order = {
      name: event.target.name.value,
      contact: event.target.contact.value,
      email: event.target.email.value,
      bikeModel: event.target.bikeModel.value,
      bikeMake: event.target.bikeMake.value,
      manufacturingYear: event.target.manufacturingYear.value,
      estimatedValue: event.target.estimatedValue.value,
    };

    try {
      const response = await axios.post(saveapi, order);
      console.log('Order saved successfully:', response.data);
      alert('Order Confirmed');
      navigate('/our'); // Replace '/confirmation' with your confirmation page route
    } catch (error) {
      console.error('Error saving order:', error);
      alert('Error saving order');
    }
  };

  return (
    <div>
      <div>
        <div className='container-fluid trvl'>
          <h5><marquee>LIMITED TIME OFFER...Offering upto 10% discount on Bike Insurance.</marquee></h5>
        </div>
        {/* <br /> */}

        <div className="container">
          <div className="row">
            <div className="col-12 col-sm-6 mb-3 mb-sm-0 px-0 px-sm-3">
              <img src="./assets/img/bike.png" className="img-fluid" id='hu1' alt="Bike Image" />
            </div>

            <div className="col-sm-6 mb-3 mb-sm-0" id="d1">
              <h3 className='cl32 text-center'>Enter Your Details</h3>

              <form onSubmit={saveBikeOrder}>
                <select className="form-control form-control-md" name='bikeMake' required onChange={handleChange}>
                  <option value=''>Choose Your Bike Make</option>
                  {bikeMake.map((content, index) => (
                    <option key={index} value={content}>{content}</option>
                  ))}
                </select>
                <br />
                <select className="form-control form-control-md" name='bikeModel' required>
                  <option value=''>Choose Your Bike Model</option>
                  {bikeModel.map((content, index) => (
                    <option key={index} value={content.productModel}>{content.productModel}</option>
                  ))}
                </select>
                <br />
                <input
  className="form-control form-control-md"
  name="manufacturingYear"
  placeholder="Manufacturing Year"
  type="number" // Ensure it's a number field
  min="2010" // Minimum year should be 2000
  required
/>
                <br />
                <input
                className="form-control form-control-md"
                name="estimatedValue"
                placeholder="Current Value"
                value={number}
                onChange={handleEstimatedValueChange} // Call function on change
                required
              />
              {words && <p className="white">{words}</p>} {/* Display words below */}
                <br />
                <input className="form-control form-control-md" name='name' placeholder="Enter Your Name" required />
                <br />
                <input className="form-control form-control-md" name='contact' placeholder="Enter Your Contact No" required />
                <br />
                <input className="form-control form-control-md" name='email' type='email' placeholder="Enter Your Email" required />
                <br />
                <div id='d2' className="text-center">
                  <button type="submit" className="btn btn-danger btn-lg">Submit</button>
                </div>
                <br />
              </form>
            </div>
          </div>
        </div>

        <Logos />
        <br /><br /><br /><br />
        <Review />
        <br /><br /><br />
      </div>
<div id="ss">
      <div class="insurance-wrapper">
    <h2>TYPES OF BIKE INSURANCE</h2>
    <p class="subheading">Ride with confidence. Choose from our range of bike insurance policies to ensure your journey is safe and secure.</p>
    
    <div class="cards-wrapper">
        <div class="insurance-card">
            <div class="card-icon"><i class="fas fa-motorcycle"></i></div>
            <h3>Comprehensive Bike Insurance</h3>
            <p>"Cover your bike against theft, damage, or accidents with Comprehensive Bike Insurance. Ensure full protection for your bike and peace of mind for your rides."</p>
        </div>
        <div class="insurance-card">
            <div class="card-icon"><i class="fas fa-shield-alt"></i></div>
            <h3>Third-Party Liability Insurance</h3>
            <p>"Stay secure with Third-Party Liability Insurance. Protect yourself against damages to third parties or their property in the event of an accident."</p>
        </div>
        <div class="insurance-card">
            <div class="card-icon"><i class="fas fa-tools"></i></div>
            <h3>Own Damage Cover</h3>
            <p>"Protect your bike from accidental damage with Own Damage Cover. Stay prepared for unforeseen repair expenses and ride stress-free."</p>
        </div>
    </div>
</div>
</div>

      <div className="bg-light">
        <br /> <br />
        <h1 className="achieve1 text-center">GET INSURED IN THREE EASY STEPS</h1>
        <br /><br />
        <div className="container">
          <div className="row">
            <div className="col-12 col-sm-4 mb-4">
              <div id="mid">
              <img src='../assets/img/icon5.png' width='150px' alt="Step 1" /></div>
              <br /><br />
              <h3 className='cl1'><strong>Compare Plans</strong></h3>
              <p className='cl1'>View and Compare Quotes from different Insurance Companies</p>
            </div>

            <div className="col-12 col-sm-4 mb-4">
              <div id="mid">
              <img src='../assets/img/icon4.png' width='150px' alt="Step 2" /></div>
              <br /><br />
              <h3 className='cl1'><strong>Buy Online</strong></h3>
              <p className='cl1'>Get insured from the company of your choice instantly</p>
            </div>

            <div className="col-12 col-sm-4 mb-4">
              <div id="mid">
              <img src='../assets/img/icon7.png' width='150px' alt="Step 3" /></div>
              <br /><br />
              <h3 className='cl1'><strong>Enter Details</strong></h3>
              <p className='cl1'>Answer basic questions to receive personalized quotes</p>
            </div>
          </div>
        </div>
      </div>

      <br /><br />

      <Footer />
    </div>
  );
}
